<script lang="ts">
  import { ShoppingCart } from '@lucide/svelte'
  import { page } from '@inertiajs/svelte'
  import { SITE_UI_KEY, type SiteUiState } from '~/lib/site-ui-context.svelte'
  import { siteCartStore } from '~/lib/site-cart-store.svelte'
  import { resolveSiteCart } from '~/lib/site-cart-view'
  import { getContext } from 'svelte'

  const siteUi = getContext<SiteUiState>(SITE_UI_KEY)

  const displayCart = $derived(
    resolveSiteCart(siteCartStore.snapshot, $page.props as Record<string, unknown>)
  )

  const visible = $derived(displayCart.count > 0)
</script>

{#if visible}
  <button
    type="button"
    class="fixed bottom-5 right-4 z-50 flex max-w-[min(100%,calc(100%-2rem))] items-center gap-2 rounded-full border border-[#7AB547]/40 bg-[#7AB547] px-4 py-3 text-sm font-bold text-[#09100a] shadow-xl shadow-[#7AB547]/30 transition-transform hover:scale-[1.03] active:scale-[0.98] sm:bottom-6 sm:right-6 sm:gap-2.5 sm:px-5 sm:py-3.5"
    style="padding-bottom: max(0.875rem, env(safe-area-inset-bottom));"
    aria-label="Открыть корзину"
    onclick={() => siteUi.openCartDrawer()}
  >
    <ShoppingCart class="size-5" />
    <span>{displayCart.count} кг</span>
    <span class="hidden sm:inline">· {displayCart.total} ₽</span>
  </button>
{/if}
